import { ArrowRight } from "lucide-react";
import { NAV_LINKS, ACTIVITY_PAUSED, PAUSE_CTA_LABEL } from "../lib/constants";
import { useActiveSection } from "../hooks/useActiveSection";

const NAV_HASHES = NAV_LINKS.map((l) => l.href);

export function DesktopNav({ navHref }) {
    const active = useActiveSection(NAV_HASHES);
    return (
        <nav
            className="hidden lg:flex items-center gap-1 p-1.5 border border-slate-200 rounded-full bg-white/60 backdrop-blur-sm"
            aria-label="Navigation principale"
        >
            {NAV_LINKS.map((l) => {
                const isActive = active === l.href;
                return (
                    <a
                        key={l.href}
                        href={navHref(l.href)}
                        aria-current={isActive ? "true" : undefined}
                        className={`relative font-display px-6 py-2.5 rounded-full text-[17px] font-medium tracking-tight transition-all duration-200 whitespace-nowrap hover:text-[#F9F9F8] hover:bg-[#0B132B] after:content-[''] after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:w-1 after:h-1 after:rounded-full after:bg-[#0B132B] after:transition-opacity after:duration-300 hover:after:opacity-0 ${
                            isActive
                                ? "text-[#0B132B] after:opacity-100"
                                : "text-[#0B132B]/85 after:opacity-0"
                        }`}
                        data-testid={`nav-${l.href.replace("#", "")}`}
                    >
                        {l.label}
                    </a>
                );
            })}
        </nav>
    );
}

export function MobileNav({ navHref, onClose }) {
    const active = useActiveSection(NAV_HASHES);
    return (
        <div className="lg:hidden pb-6 border-t border-slate-200 pt-5 flex flex-col gap-5">
            {NAV_LINKS.map((l) => {
                const isActive = active === l.href;
                return (
                    <a
                        key={l.href}
                        href={navHref(l.href)}
                        onClick={onClose}
                        aria-current={isActive ? "true" : undefined}
                        className={`relative inline-flex items-center text-base font-medium text-[#0B132B] before:content-[''] before:absolute before:-left-3 before:top-1/2 before:-translate-y-1/2 before:w-1 before:h-1 before:rounded-full before:bg-[#0B132B] before:transition-opacity before:duration-300 ${
                            isActive ? "before:opacity-100" : "before:opacity-0"
                        }`}
                        data-testid={`mobile-nav-${l.href.replace("#", "")}`}
                    >
                        {l.label}
                    </a>
                );
            })}
            <a
                href={navHref("#contact")}
                onClick={onClose}
                className={
                    ACTIVITY_PAUSED
                        ? "inline-flex items-center justify-center gap-2 px-5 py-3 border border-slate-300 text-slate-600 bg-white text-base font-medium rounded-full mt-2"
                        : "inline-flex items-center justify-center gap-2 px-5 py-3 bg-[#0B132B] text-[#F9F9F8] text-base font-medium rounded-full mt-2"
                }
                data-testid="mobile-nav-contact-cta"
                aria-label={ACTIVITY_PAUSED ? "Activité en pause. En savoir plus." : undefined}
            >
                {ACTIVITY_PAUSED ? PAUSE_CTA_LABEL : "Me contacter"}
                {!ACTIVITY_PAUSED && <ArrowRight className="w-4 h-4" />}
            </a>
        </div>
    );
}
